export default {
    columns: {
        type: Array,
        default: undefined
    }, 
    measures: {
        type: Array,
        default: undefined
    }, 
    rows: {
        type: Array,
        default: undefined
    }, 
    transport:  {
        type: Object,
        default: undefined
    }, 
    schema:  {
        type: Object,
        default: undefined
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoPivotDataSource/PivotDataSourceProps.js